import {
  createContext,
  type SetStateAction,
  type Dispatch,
  type Context,
} from 'react';

export type MenuContextProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isDefaultOpen: boolean;
};

export const MenuContext: Context<MenuContextProps> =
  createContext<MenuContextProps>({
    isOpen: false,
    isDefaultOpen: false,
    setIsOpen: () => null,
  });
